import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getCouponsBasedOnDomainAction } from "../../../../Store/CouponBaseOnDomain/actions";
import {
  getCouponByIdAction,
  getRecommendBannerAction,
} from "../../../../Store/Coupons/actions";
import "../../../../Assets/Scss/newHome2.scss";
import { getImageUrlhttps } from "../../../../Utils/index";
import PlaceHolderImage from "../../../../Assets/Images/PlaceholderImage.png";
import { getCouponUrlAction } from "../../../../Store/couponUrl/actions";
import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import { BASE_URL } from "../../../../Config/axiosInstance";
import CentralCouponRedirect from "../../../../Utils/CentralCouponRedirect";

const zoomInAnimation = keyframes`${zoomIn}`;

const ZoomInDiv = styled.div`
  animation: 1s ${zoomInAnimation};
`;

function Deals({ match }) {
  const dispatch = useDispatch();

  const { couponbaseondomainList } = useSelector(
    (store) => store.CouponBasedOnDomain
  );
  const { link } = useSelector((state) => state.CouponUrl);

  const [redirect, setRedirect] = useState(false);
  const [redirect2, setRedirect2] = useState(false);
  const [newTab, setNewTab] = useState(false);
  const [second, setSecond] = useState(false);
  const [useRedirectComponent, setUseRedirectComponent] = useState(false);

  const { couponByID, getRecommendBanner } = useSelector(
    (state) => state.Coupon
  );

  useEffect(() => {
    if (
      match?.params?.couponId !== undefined &&
      couponByID?._id === undefined
    ) {
      dispatch(getCouponByIdAction({ coupon_id: match.params.couponId }));
    }
    if (
      match?.params?.couponId !== undefined &&
      couponByID?._id !== undefined
    ) {
      window.open(
        `/couponsredirect/${match.params.storeName}/${match.params.couponId}`
      );
    }
  }, [match, couponByID, dispatch]);

  useEffect(() => {
    localStorage.setItem("link", link);
    if (redirect) {
      setNewTab(!newTab);
    }
    if (redirect2) {
      setNewTab(!newTab);
    }
  }, [link, second]);

  useEffect(() => {
    if (link && redirect) {
      setRedirect(false);
      window.open(`/meta-redirect/`, "_blank");
    }
    if (link && redirect2) {
      setRedirect2(false);
      window.open(link, "_blank");
    }
  }, [newTab]);

  useEffect(() => {
    dispatch(getRecommendBannerAction({ dimension: "300 * 250" }));
    dispatch(getCouponsBasedOnDomainAction());
  }, [dispatch]);

  return (
    <div
      id="deals-i4"
      style={{ background: "#F3F4F6", paddingLeft: "10px", position: "static" }}
      className="pt-0"
    >
      {useRedirectComponent && (
        <CentralCouponRedirect
          e={useRedirectComponent.e}
          coupon={useRedirectComponent.coupon}
          setUseRedirectComponent={setUseRedirectComponent}
        ></CentralCouponRedirect>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          allignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "250px",
            justifyContent: "center",
            fontSize: "17px",
            borderRadius: "5px  5px 34px 34px",
            background: "#374158",
            color: "#F9FAFB",
            marginBottom: "12px",
            height: "19px",
            fontWeight: "600",
            paddingBottom: "2px",
          }}
        >
          <p
            id="top-deals-i4"
            style={{
              width: "200px",
              height: "23px",
              background: "#37415f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "35px 35px 0 0",
            }}
          >
            Top Deals
          </p>
        </div>
      </div>
      <Container
        id="recommended-res-cards-i3"
        className="deals-cards-i4"
        style={{ position: "static" }}
      >
        <Row>
          {couponbaseondomainList.slice(0, 20).map((coupon, i) => (
            <Col xl="3" sm="6">
              <>
                {i === 3 && (
                  <div
                    className="col"
                    style={{ marginBottom: "8%", height: "426px" }}
                  >
                    <ZoomInDiv
                      className="d-flex align-items-center flex-column justify-content-center couponCard h-100"
                      onClick={() =>
                        window.open(
                          getRecommendBanner[0]?.redirect_url,
                          "_blank"
                        )
                      }
                    >
                      <img
                        style={{
                          objectFit: "contain",
                        }}
                        loading="lazy"
                        src={`${BASE_URL}/${getRecommendBanner[0]?.image_upload}`}
                        alt=""
                      />
                    </ZoomInDiv>
                  </div>
                )}
                {i === 11 && (
                  <div
                    className="col"
                    style={{ marginBottom: "8%", height: "426px" }}
                  >
                    <ZoomInDiv
                      className="d-flex align-items-center flex-column justify-content-center couponCard h-100"
                      onClick={() =>
                        window.open(
                          getRecommendBanner[1]?.redirect_url,
                          "_blank"
                        )
                      }
                    >
                      <img
                        style={{
                          objectFit: "contain",
                        }}
                        loading="lazy"
                        src={`${BASE_URL}/${getRecommendBanner[1]?.image_upload}`}
                        alt=""
                      />
                    </ZoomInDiv>
                  </div>
                )}
                {i !== 3 && i !== 11 && (
                  <div className="col" style={{ marginBottom: "8%" }}>
                    {" "}
                    <div className="card shadow-sm" style={{ height: "430px" }}>
                      {" "}
                      <a
                        className="small text-muted"
                        style={{ color: "rgb(2, 137, 80)" }}
                      >
                        {coupon?.category}
                      </a>{" "}
                      <span
                        className=" badge bg-secondary"
                        style={{
                          position: "absolute",
                          right: "1px",
                          top: "2px",
                          background: "#212121",
                        }}
                      >
                        {coupon?.status || "Verified"}
                      </span>{" "}
                      <img
                        src={getImageUrlhttps(
                          coupon?.image ? coupon?.image : coupon?.store?.image,
                          PlaceHolderImage
                        )}
                        className="card-img-top"
                        alt="..."
                        loading="lazy"
                        style={{
                          height: "200px",
                        }}
                      />{" "}
                      <div className="card-body">
                        {" "}
                        <div className="clearfix mb-3">
                          <span className="float-end"></span>{" "}
                        </div>{" "}
                        <h5 className="card-title" style={{ color: "#212121" }}>
                          {coupon?.title.slice(0, 45)}
                        </h5>{" "}
                        <div className="text-center my-4">
                          {" "}
                          <a
                            //     onClick={(e)=>{
                            //         e.stopPropagation();

                            //   dispatch(getCouponUrlAction( coupon?._id, `${window.screen.width}x${window.screen.height}`
                            //               ,`/couponsredirect/store/$store/coupon/store/${
                            //             coupon?._id
                            //           }`));

                            //           if(link){
                            //             setSecond(true); //to run useEffect even when link has not changed
                            //           }

                            // if(coupon?.redirection_type === "zero-redirect-without-refer"){
                            //     setRedirect(true);
                            // }else if(coupon?.redirection_type === "zero-redirect-with-refer"){
                            //   setRedirect2(true);
                            // }else{

                            //           localStorage.setItem("redirection_type", coupon?.redirection_type);

                            //         window.open(
                            //           `/couponsredirect/store/store/coupon/store/${
                            //             coupon?._id
                            //           }`,
                            //           "_blank"
                            //         );
                            //         }
                            //       }}

                            onClick={(e) => {
                              e.preventDefault();
                              setUseRedirectComponent({ e, coupon });
                            }}
                            className="btn btn-warning"
                            style={{
                              background: "#212121",
                              color: "#fff",
                              borderColor: "rgb(2, 137, 80)",
                              boxShadow: "none",
                              padding: "5px 10px",
                            }}
                          >
                            Get This Offer Now{" "}
                          </a>{" "}
                        </div>{" "}
                        <div
                          className="text-center my-4"
                          style={{ fontWeight: "700" }}
                        >
                          {coupon?.expiry_date ? (
                            <p>
                              VALID UNTIL -{" "}
                              <span style={{ color: "red" }}>
                                {coupon?.expiry_date?.slice(0, 10)}
                              </span>
                            </p>
                          ) : (
                            <br />
                          )}
                        </div>
                        <div className="clearfix mb-1">
                          {" "}
                          <span className="float-start">
                            <i className="far fa-question-circle" />
                          </span>{" "}
                          <span className="float-end">
                            <i className="fas fa-plus" />
                          </span>{" "}
                        </div>{" "}
                      </div>{" "}
                    </div>{" "}
                  </div>
                )}{" "}
              </>
            </Col>
          ))}
        </Row>
      </Container>
      <br />
    </div>
  );
}

export default Deals;
